import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStickyNote } from "@fortawesome/free-regular-svg-icons";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";

import eventEmitter from "../../shared/events";

const NoteButton = (props) => {
    const icon = props.hasNotes ? faStickyNote : faPencilAlt;

    const onNoteClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        eventEmitter.emit("UPDATE_NOTE_SETTINGS", {
            binTrackingNumber: props.binTrackingNumber,
            clientCode: props.cxHClientCode,
            noteType: props.noteType,
            shipmentKey: props.shipmentKey,
            shipmentProductKey: props.shipmentProductKey,
            showAll: props.showAll,
            upc: props.upc,
            sourcePage: props.sourcePage,
            isReadOnly: props.isReadOnly,
        });
    };

    return (
        <button className="button -text" onClick={onNoteClick}>
            <FontAwesomeIcon icon={icon} />
        </button>
    );
};

export default NoteButton;
